import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategorizedComponent } from './pa-categorized/pa-categorized.component';
import { LoadComponent } from './pa-load/pa-load.component';
import { OverallComponent } from './pa-overall/pa-overall.component';
import { PetitionAnalysisLibraryModule } from 'petition-analysis-library';
import { PetitionAnalysisContainerRoutingModule } from './petition-analysis-routing.module';


@NgModule({
  declarations: [
    CategorizedComponent,
    LoadComponent,
    OverallComponent
  ],
  imports: [
    CommonModule,
    PetitionAnalysisContainerRoutingModule,
    PetitionAnalysisLibraryModule
  ]
})
export class PetitionAnalysisContainerModule { }
